import { useFormContext } from "react-hook-form";
import { ErrorMessage, TextInput, Typography } from "@/components/atoms";
import { clsx } from "@/utils";
import { SignUpClientFormData } from "../types";

export const JobTitleField = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<SignUpClientFormData>();

  return (
    <div className={clsx("flex flex-col gap-y-1", className)} {...props}>
      <Typography variant="paragraph">Job Title</Typography>
      <TextInput
        className="w-full"
        hasError={!!errors.jobTitle}
        placeholder="Select Your Title"
        maxLength={100}
        {...register("jobTitle")}
      />
      <Typography variant="small" className="text-neutral-dark-gray">Optional</Typography>
      <ErrorMessage errors={errors} name="jobTitle" />
    </div>
  );
};
